import React, { Component } from 'react';
import Header from '../../components/Header/Header';
import './styles.css';
export default class Login extends Component {

  constructor(props) {
    super(props);

  }

  render() {
    return (
      <Header
        history={this.props.history}
      >
        <div className="login">
          <form className="login__form">
            <div className="login__form__content">
              <label htmlFor="email" className="login__form__content__label"  > EMAIL </label>
              <input type="text" className="login__form__content__input" />
              <label htmlFor="email" className="login__form__content__label"  > SENHA </label>
              <input type="password" className="login__form__content__input" />
              <div className="login__form__content__forgotcontent">
                <a href="a" className="login__form__content__forgotPassword"  > Esqueceu sua senha? </a>
              </div>
            </div>
            <div className="login__form__contentbutton">
              <button className="login__form__contentbutton__button">Entrar</button>
            </div>
          </form>
        </div>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login/index.js